import { AppError } from 'ozira-app-core';

// Only shared AppError messages are safe to show directly: the API client
// constructs them from its sanitized error taxonomy and never includes
// credentials, response headers, or server stack traces.
export function assistantSendErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof AppError) {
    const message = error.message.trim();
    if (message) return message;
  }
  return fallback;
}
